function LogoAldys() {
  return (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.3017 22.4868V24.2737H16.0533C19.5393 24.2737 26.6369 17.9274 26.6369 10.1508V8.36313H17.5196C10.8156 8.36313 5.36313 14.352 5.36313 24.2737V29.6369H0V23.0223C0 13.7263 6.34637 3 17.4302 3H32V10.1508C32 19 24.9385 29.6369 16.0533 29.6369H8.93855V24.2737C8.93855 16.229 13.1397 11.9385 17.5196 11.9385H22.916C22.916 13.3687 21.9651 15.6927 21.0441 16.6138C17.6983 16.6138 14.3017 18.6961 14.3017 22.4868Z" fill="#29A383"/>
  </svg>
  );
}

export default LogoAldys;
